export class Utils {

    static getCookie(name, like = false) {
        return document.cookie.split('; ').reduce((r, v) => {
            const parts = v.split('=');
            return (like ? parts[0].match(name) : parts[0] === name) ? decodeURIComponent(parts[1]) : r
        }, '')
    }

    static setCookie (name, value, days = 30, path = '/',domain = null) {
        const expires = new Date(Date.now() + days * 864e5).toUTCString()
        domain = domain || this.getDomain(window.location.hostname)
        document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=' + path + '; domain=' + domain
    }

    static getDomain(hostName) {
        return hostName.substring(hostName.lastIndexOf(".", hostName.lastIndexOf(".") - 1) + 1);
    }

    static getNavigatorLanguage(context)
    {
        return context.navigator.language || context.navigator.browserLanguage || context.navigator.userLanguage;
    }

    static toQueryParams(queryParameters) {
        const searchParams = new URLSearchParams();
        Object.keys(queryParameters).forEach(key => searchParams.append(key, queryParameters[key]));
        console.log(searchParams.toString());
        return searchParams.toString();
    }

    static iframeAddContent(iframe, content) {
        const document = (iframe.contentWindow || (iframe.contentDocument.document || iframe.contentDocument)).document;
        document.open();
        document.write(content);
        document.close();
    }
}